// Recovered compiled webpack factory 91815. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n;
  r.d(t, { NI: () => d, Nc: () => R, jw: () => _, q3: () => y });
  var a = r(87624),
    o = r(88722),
    i = r(49636),
    s = r(39619),
    l = r(47022),
    u = r(71702),
    c = r(95704);
  function f(e) {
    return e.length > 1 && e.endsWith("/") ? e.slice(0, -1) : e;
  }
  let d = "incomplete-app-router-transaction",
    p = "router-patch",
    h = { current: void 0 };
  function _(e) {
    let t = f(s.jf.location.pathname),
      r = (0, u.D)(t),
      n = (0, a.k3)();
    (0, l.Sx)(e, {
      name: r ?? t,
      startTime: n ? n / 1e3 : void 0,
      attributes: {
        [o.uT]: "pageload",
        [o.JD]: "auto.pageload.nextjs.app_router_instrumentation",
        [o.i_]: r ? "route" : "url",
      },
    });
  }
  let m = i.O,
    g = i.O;
  function y(e) {
    ((n = (t, r) => {
      let n = c.env._sentryBasePath ?? g._sentryBasePath,
        a = f(new URL(n && !t.startsWith(n) ? `${n}${t}` : t, s.jf.location.href).pathname),
        i = (0, u.D)(a),
        d = i ?? a;
      "router-patch" === p && (p = "transition-start-hook");
      let _ = h.current;
      _
        ? (_.updateName(d),
          _.setAttributes({ "navigation.type": `router.${r}`, [o.i_]: i ? "route" : "url" }),
          (h.current = void 0))
        : (0, l.Nt)(e, {
            name: d,
            attributes: {
              [o.uT]: "navigation",
              [o.JD]: "auto.navigation.nextjs.app_router_instrumentation",
              [o.i_]: i ? "route" : "url",
              "navigation.type": `router.${r}`,
            },
          });
    }),
      s.jf.addEventListener("popstate", () => {
        let t = f(s.jf.location.pathname),
          r = (0, u.D)(t);
        h.current?.isRecording()
          ? (h.current.updateName(r ?? t), h.current.setAttribute(o.i_, r ? "route" : "url"))
          : (h.current = (0, l.Nt)(e, {
              name: r ?? t,
              attributes: {
                [o.JD]: "auto.navigation.nextjs.app_router_instrumentation",
                [o.i_]: r ? "route" : "url",
                "navigation.type": "browser.popstate",
              },
            }));
      }));
    let t = !1,
      r = 0,
      a = setInterval(() => {
        r++;
        let n = m?.next?.router ?? m?.nd?.router;
        t || r > 500
          ? clearInterval(a)
          : n &&
            (clearInterval(a),
            (t = !0),
            E(e, n, h),
            ["nd", "next"].forEach((t) => {
              let r = m[t];
              r &&
                (m[t] = new Proxy(r, {
                  set: (t, r, n) => (
                    "router" === r && "object" == typeof n && null !== n && E(e, n, h),
                    (t[r] = n),
                    !0
                  ),
                }));
            }));
      }, 20);
  }
  function v(e) {
    try {
      return new URL(e, "http://example.com/").pathname;
    } catch {
      return "/";
    }
  }
  let b = new WeakSet();
  function E(e, t, r) {
    b.has(t) ||
      (b.add(t),
      ["back", "forward", "push", "replace"].forEach((n) => {
        t?.[n] &&
          (t[n] = new Proxy(t[n], {
            apply(t, a, i) {
              if ("router-patch" !== p) return t.apply(a, i);
              let s = d,
                h = {
                  [o.uT]: "navigation",
                  [o.JD]: "auto.navigation.nextjs.app_router_instrumentation",
                  [o.i_]: "url",
                },
                _ = i[0],
                m = c.env._sentryBasePath ?? g._sentryBasePath,
                y = m && "string" == typeof _ && !_.startsWith(m) ? `${m}${_}` : _;
              "push" === n
                ? ((s = f(v(y))), (h["navigation.type"] = "router.push"))
                : "replace" === n
                  ? ((s = f(v(y))), (h["navigation.type"] = "router.replace"))
                  : "back" === n
                    ? (h["navigation.type"] = "router.back")
                    : "forward" === n && (h["navigation.type"] = "router.forward");
              let b = (0, u.D)(s);
              return (
                (r.current = (0, l.Nt)(e, {
                  name: b ?? s,
                  attributes: { ...h, [o.i_]: b ? "route" : "url" },
                })),
                t.apply(a, i)
              );
            },
          }));
      }));
  }
  function R(e, t) {
    n && n(e, t);
  }
}
